import {
    GetSubscriptionsFn,
    initGetSubscriptionsFn,
} from './lib/methods/get-subscriptions';
import {
    IdentityHasActiveSubscriptionsFn,
    initIdentityHasActiveSubscriptionsFn,
} from './lib/methods/identity-has-active-subscriptions';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    GetSubscriptionsWithOfferDetailsFn,
    initGetSubscriptionsWithOfferDetailsFn,
} from './lib/methods/get-subscriptions-with-offer-details';
import {
    GetSubscriptionDetailsFn,
    initGetSubscriptionDetailsFn,
} from './lib/methods/get-subscription-details';
import {
    GetSubscriptionDetailsWithOfferDetailsFn,
    initGetSubscriptionDetailsWithOfferDetailsFn,
} from './lib/methods/get-subscription-details-with-offer-details';
import {
    GetSmsSubscriptionsWithOfferDetailsFn,
    initGetSmsSubscriptionsWithOfferDetailsFn,
} from './lib/methods/get-sms-subscriptions-with-offer-details';
import {
    GetProductRedeemUrlFn,
    initGetProductRedeemUrlFn,
} from './lib/methods/get-product-redeem-url';
import {
    GetProductRedemptionStatusFn,
    initGetProductRedemptionStatusFn,
} from './lib/methods/get-product-redemption-status';
import {
    GetPotentialDevicesForSubscriptionFn,
    initGetPotentialDevicesForSubscriptionFn,
} from './lib/methods/get-potential-devices-for-subscription';
import {
    GetSubscriptionLinkingEligibilityForRadioIdFn,
    initGetSubscriptionLinkingEligibilityForRadioIdFn,
} from './lib/methods/get-subscription-linking-eligibility-for-radio-id';
import {
    GetSubscriptionLinkingEligibilityForVinFn,
    initGetSubscriptionLinkingEligibilityForVinFn,
} from './lib/methods/get-subscription-linking-eligibility-for-vin';
import {
    GetSubscriptionLinkingEligibilityForLicensePlateFn,
    initGetSubscriptionLinkingEligibilityForLicensePlateFn,
} from './lib/methods/get-subscription-linking-eligibility-for-license-plate';

export interface DomainSubscriptions {
    getSubscriptionsWithOfferDetails: GetSubscriptionsWithOfferDetailsFn;
    getSubscriptions: GetSubscriptionsFn;
    getSubscriptionDetails: GetSubscriptionDetailsFn;
    getSubscriptionDetailsWithOfferDetails: GetSubscriptionDetailsWithOfferDetailsFn;
    getSubscriptionLinkingEligibilityForLicensePlate: GetSubscriptionLinkingEligibilityForLicensePlateFn;
    getSubscriptionLinkingEligibilityForRadioId: GetSubscriptionLinkingEligibilityForRadioIdFn;
    getSubscriptionLinkingEligibilityForVin: GetSubscriptionLinkingEligibilityForVinFn;
    identityHasActiveSubscriptions: IdentityHasActiveSubscriptionsFn;
    getSmsSubscriptionsWithOfferDetails: GetSmsSubscriptionsWithOfferDetailsFn;
    getProductRedeemUrl: GetProductRedeemUrlFn;
    getProductRedemptionStatus: GetProductRedemptionStatusFn;
    getPotentialDevicesForSubscription: GetPotentialDevicesForSubscriptionFn;
}

export function domainSubscriptions(
    domainInitPayload: DomainInitPayload,
): DomainSubscriptions {
    return {
        getSubscriptionsWithOfferDetails:
            initGetSubscriptionsWithOfferDetailsFn(domainInitPayload),
        getSubscriptions: initGetSubscriptionsFn(domainInitPayload),
        getSubscriptionDetails: initGetSubscriptionDetailsFn(domainInitPayload),
        getSubscriptionDetailsWithOfferDetails:
            initGetSubscriptionDetailsWithOfferDetailsFn(domainInitPayload),
        getSubscriptionLinkingEligibilityForLicensePlate:
            initGetSubscriptionLinkingEligibilityForLicensePlateFn(
                domainInitPayload,
            ),
        getSubscriptionLinkingEligibilityForRadioId:
            initGetSubscriptionLinkingEligibilityForRadioIdFn(
                domainInitPayload,
            ),
        getSubscriptionLinkingEligibilityForVin:
            initGetSubscriptionLinkingEligibilityForVinFn(domainInitPayload),
        identityHasActiveSubscriptions:
            initIdentityHasActiveSubscriptionsFn(domainInitPayload),
        getSmsSubscriptionsWithOfferDetails:
            initGetSmsSubscriptionsWithOfferDetailsFn(domainInitPayload),
        getProductRedeemUrl: initGetProductRedeemUrlFn(domainInitPayload),
        getProductRedemptionStatus:
            initGetProductRedemptionStatusFn(domainInitPayload),
        getPotentialDevicesForSubscription:
            initGetPotentialDevicesForSubscriptionFn(domainInitPayload),
    };
}
